import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import Slide from '@material-ui/core/Slide'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import { processEnv } from 'components/configuration/environmentVariables'
import React from 'react'
import { DialogContext } from './DialogContext'

const useStyles = makeStyles((theme: Theme) => ({
    productContainer: {
        width: '100%',
        overflow: 'hidden',
    },
    productContainerHeightWithBanner: {
        height: `calc(100vh - 257px)`,
    },
    productContainerDefaultHeight: (props: { enablePPLFeature: boolean }) => ({
        height: props.enablePPLFeature ? `calc(100vh - 70px)` : `calc(100vh - 111px)`,
    }),
    dialogContainer: {
        overflowY: 'auto',
        overflowX: 'hidden',
        backgroundColor: '#F1F1F1',
    },
    dialogContainerDefaultHeight: {
        height: `calc(100vh - 125px)`,
    },
    dialogContainerWithBanner: {
        height: `calc(100vh - 270px)`,
    },
    fullHeight: { height: '100%' },
}))

interface DialogContentProps {
    slideContent: React.ReactNode
    isBannerExpanded: boolean
}

export const DialogContent: React.FC<DialogContentProps> = ({
    slideContent,
    isBannerExpanded,
    children,
}) => {
    const classes = useStyles({ enablePPLFeature: processEnv.REACT_APP_EnablePPLFeature === '1' })
    const { slideOpen, isAdvancedFiltersOpen } = React.useContext(DialogContext)

    return (
        <GridContainer
            data-testid="divProductContainer"
            className={clsx(
                classes.productContainer,
                isBannerExpanded
                    ? classes.productContainerHeightWithBanner
                    : classes.productContainerDefaultHeight
            )}
        >
            <GridItem
                container
                direction="column"
                className={classes.fullHeight}
                xs={
                    slideOpen || isAdvancedFiltersOpen
                        ? isAdvancedFiltersOpen
                            ? 8
                            : 7
                        : 12
                }
            >
                {children}
            </GridItem>
            <Slide
                direction="left"
                in={slideOpen}
                mountOnEnter
                unmountOnExit
                timeout={0}
            >
                <GridItem
                    className={clsx(
                        classes.dialogContainer,
                        isBannerExpanded
                            ? classes.dialogContainerWithBanner
                            : classes.dialogContainerDefaultHeight
                    )}
                    xs={5}
                >
                    {slideContent}
                </GridItem>
            </Slide>
        </GridContainer>
    )
}
